
import request from '../request.js'

// 条件查询专家预约记录 ---- 郑智慧 修改人：高进
export const getExpertsRecordsList = function (data) {
    return request({
        url: 'ngsExpert/selectAllExpertApply',
        method: 'post',
        data
    })
}
// 查询专家详细预约记录 ---- 郑智慧 修改人：高进
export const getRecordsDetail = function (data) {
    return request({
        url: 'ngsExpert/getExpertApply',
        method: 'post',
        data
    })
}